import { render, staticRenderFns } from "./SmallWithImage.vue?vue&type=template&id=07ec4d53&scoped=true&"
import script from "./SmallWithImage.vue?vue&type=script&lang=js&"
export * from "./SmallWithImage.vue?vue&type=script&lang=js&"
import style0 from "./SmallWithImage.vue?vue&type=style&index=0&id=07ec4d53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec4d53",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,ArrowButton: require('/vercel/path0/components/general/ArrowButton.vue').default})
